// 根据msg判断是否为“断网、网络超时”
const isNetworkError = function (msg) {
  let ret = false;
  if (msg === 'Network Error' || msg.indexOf('timeout of') > -1) {
    ret = true;
  }
  return ret;
};

// 处理断网超时异常
const catchErr = {
  catchErr(Err) {
    const DEFAULT_MSG = '请求出错了';
    // 外包项目大群里沟通结论：所有“断网请求、请求超时”使用统一的提示语
    const NETWORK_MSG = '网络连接超时，请稍后再试';
    let errMsg = DEFAULT_MSG;

    if (typeof Err === 'string') {
      errMsg = Err;
      // 外包项目大群里沟通结论：所有“断网请求、请求超时”使用统一的提示语
      if (isNetworkError(Err)) {
        errMsg = NETWORK_MSG;
      }
    } else if (typeof Err === 'object') {  // 如果是Error对象
      errMsg = Err.msg || Err.message || DEFAULT_MSG;
      // 服务器500错误：比如,php的ajax接口挂掉了
      if (Err.status === 500) {
        errMsg = '服务器出错了';
      } else if (isNetworkError(errMsg)) {
        errMsg = NETWORK_MSG;
      }
    }
    return errMsg;
  },
};

export default catchErr;
